module.exports = __webpack_public_path__ + "static/media/person.f6a772e5.png";